import { render } from "./CustomUI.vue?vue&type=template&id=5b70634e&scoped=true&lang=pug"
import script from "./CustomUI.vue?vue&type=script&lang=ts"
export * from "./CustomUI.vue?vue&type=script&lang=ts"

import "./CustomUI.vue?vue&type=style&index=0&id=5b70634e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5b70634e"

export default script